var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnestroiScBlockchainPolkadot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.464,
    height: 63.554,
    viewBox: "0 0 67.464 63.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "polkadot-new-dot-logo",
    transform: "translate(76.919 1.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4212",
    "data-name": "Ellipse 4212",
    cx: 10.92,
    cy: 6.351,
    rx: 10.92,
    ry: 6.351,
    transform: "translate(-54.106 0)",
    fill: "none",
    stroke: "#0e8ece",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4213",
    "data-name": "Ellipse 4213",
    cx: 10.92,
    cy: 6.351,
    rx: 10.92,
    ry: 6.351,
    transform: "translate(-54.106 47.852)",
    fill: "none",
    stroke: "#012043",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4214",
    "data-name": "Ellipse 4214",
    cx: 10.92,
    cy: 6.355,
    rx: 10.92,
    ry: 6.355,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -74.87, 24.594)",
    fill: "none",
    stroke: "#012043",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4215",
    "data-name": "Ellipse 4215",
    cx: 10.92,
    cy: 6.351,
    rx: 10.92,
    ry: 6.351,
    transform: "matrix(0.5, -0.866, 0.866, 0.5, -33.426, 48.522)",
    fill: "none",
    stroke: "#0e8ece",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4216",
    "data-name": "Ellipse 4216",
    cx: 6.355,
    cy: 10.92,
    rx: 6.355,
    ry: 10.92,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -74.869, 35.96)",
    fill: "none",
    stroke: "#012043",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4217",
    "data-name": "Ellipse 4217",
    cx: 6.351,
    cy: 10.92,
    rx: 6.351,
    ry: 10.92,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, -33.423, 12.036)",
    fill: "none",
    stroke: "#0e8ece",
    strokeWidth: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnestroiScBlockchainPolkadot);
export default __webpack_public_path__ + "static/media/earnestroi-sc-blockchain-polkadot.bfbd86cf6f2f6e2c3e69e527fd94179c.svg";
export { ForwardRef as ReactComponent };